<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- SNMP参数 -->
            <el-tab-pane>
                <span slot="label"> {{ $t("logs.snmp1") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <td>{{ $t("logs.snmp2") }}:</td>
                                <td>
                                    <el-input v-model="ip_source" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.snmp3") }}:</td>
                                <td>
                                    <el-input v-model="community" placeholder=""></el-input>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_gray()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            community: '',
            ip_source: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            data_loadok1: '',
            show_hint1: '',
            show_hint2: '',
        };
    },
    mounted() {
        this.getFileList1()
    },
    methods: {
        save_gray() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_snmp_param",
                sid: sid,
                // byad: this.byad == true ? 1 : 0,

                community: this.community,
                ip_source: this.ip_source,

                data_loadok: this.data_loadok1

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
              

        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_snmp_param",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.data_loadok1 = res.data.ret.ok
                        this.community = res.data.ret.result.community

                        this.ip_source = res.data.ret.result.source

                    }
                })
              
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
    padding-left: 14px;
}
</style>
